@if(notifications.length)
{
  <mat-expansion-panel class="notifications-panel warn-message" [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <span class="notification-title">
          <mat-icon class="notranslate">error_outline</mat-icon>
          Action Required ({{notifications.length}})
        </span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ul class="flex flex-column justify-content-center align-items-stretch notifications">
      @for (notification of notifications; track notification)
      {
        <li>
          <div class="notification" [class]="notification.type">
            <div class="flex flex-row justify-content-between align-items-center">
              <div class="flex flex-row justify-content-center align-items-center gap-1 content">
                @if(notification.icon)
                {
                  <mat-icon [fontIcon]="notification.icon" />
                }
                <span [innerHTML]="notification.message | safeHtml"></span>
                @if(notification.cta)
                {
                  @switch (notification.cta.type)
                  {
                    @case ("link")
                    {
                      <a class="clickable" (click)="performAction(notification)">{{ notification.cta.caption }}</a>
                    }
                    @case ("button")
                    {
                      <button mat-stroked-button (click)="performAction(notification)">{{ notification.cta.caption }}</button>
                    }
                  }
                }
              </div>
              <div>
                @if(notification.dismissible != false)
                {
                  <button mat-icon-button (click)="dismissNotification(notification)">
                    <mat-icon fontIcon="close" />
                  </button>
                }
              </div>
            </div>
          </div>
        </li>
      }
    </ul>
  </mat-expansion-panel>
}
